export const LOCALE = {
  ENGLISH: "en",
  SPANISH: "es",
  PORTUGUESE: "pt"
};